import React from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";
import followersImage from "../../Pages/Images/followers.webp"; 
import helpersImage from "../../Pages/Images/helpers.webp"; 
import JobSeekerNavbar from "../../Pages/Navbar/JobSeekerNavbar";
import Footer from "../../Footer/Footer"

const AboutUs = () => {
  const navigate = useNavigate();

  const handleContactUs = () => {
    navigate("/jobseeker-contactus");
  };

  return (
    <>
    <JobSeekerNavbar />
    <div className="about-container">
      <h2 className="about-title">About Us</h2>

      <p className="about-text">
        We, <span className="highlight">Gulf Worker</span>, are a team of ethical professionals dedicated to the betterment of the job seekers and domestic workers.
      </p>

      <p className="about-text">
        Founded in 2016, our online platform is designed to assist the employers as well as the helpers by enabling them to make informed decisions. Our working method is simple and straight;{" "}
        <strong>we connect helpers and employers seamlessly</strong>, providing both of them a fair recruitment experience.
      </p>

      <p className="about-text">
        Gone are the days when the domestic helpers were required to pay unethical, hefty fees to the employment agencies. At Gulf Worker, we are committed to providing instant access to both the parties through well structured profiles, screening and a streamlined hiring process.
      </p>

      {/* Why Choose Us Section */}
      <div className="why-container">
        <h2 className="why-title">Why choose us?</h2>

        <h3 className="sub-title">Ethical</h3>
        <p className="about-text">
          Gulf Worker advocates for fair employment practices by connecting helpers, caregivers, and other job seekers with employers without charging the workers any fees. This approach helps to prevent exploitation and ensure that the workers are not burdened with debt before they start their jobs. We follow ethical practices and look forward to better our system in the days to come.
        </p>

        <div className="followers-image-container">
          <img src={followersImage} alt="More than 150,000 Followers" className="followers-image" />
        </div>

        <h3 className="sub-title">Responsible</h3>
        <p className="about-text">
          We are highly responsible and equally passionate about what we are doing. Our moral values motivate us to strive even more and work towards the cause of <strong>developing a free and fair job market</strong>. While there are several agencies that are taking advantage of the candidates, we at Gulf Worker are working full length and beyond our capacity to ensure they get access to a fair and equitable hiring process.
        </p>
      </div>

      {/* For Helpers Section */}
      <div className="helpers-container">
        <h3 className="sub-title">For Helpers</h3>
        <p className="about-text">
          We provide <strong>FREE access to the domestic job market online</strong>. We have engineered a free marketplace wherein you can{" "}
          <span className="highlight">get in touch with potential employers directly</span>; we work to help you get placed with the right employer and strive to{" "}
          <strong>build long-term cordial working relationships</strong>. Just submit your profile for free on our platform and await your placement with the family of your choice.
        </p>

        <div className="helpers-image-container">
          <img src={helpersImage} alt="Direct Hire - Save Agency Fees - No Debt Bondage" className="helpers-image" />
        </div>
      </div>

      {/* For Employers Section */}
      <div className="employers-container">
        <h3 className="sub-title">For Employers</h3>
        <p className="about-text">
          Our online platform is designed to give you access to the best domestic helpers. Our helper listing consists of{" "}
          <strong>candidates with experience and expertise</strong>. It doesn't matter whether you are in Hong Kong, Singapore or Dubai; we assist you in{" "}
          <span className="highlight">connecting with the helper of your choice</span>. Just choose the location, post a job, start receiving applications and get set to find a helper for your family.
        </p>
      </div>

      {/* Mission Statement */}
      <div className="mission-container">
        <h3 className="sub-title">Mission Statement</h3>
        <p className="about-text">
          Our mission is to provide a <strong>fair recruitment environment</strong> and introduce more features on our platform to make it even better. We want to reach out to as many candidates and employers as possible in order to{" "}
          <strong>safely get a new job</strong>. We are proud to be one of leading platform for hiring domestic staffs. Ready to{" "}
          <span className="highlight">join our community ?</span>
        </p>
      </div>

      {/* Contact Us */}
      <div className="contact-container">
        <h3 className="sub-title">Contact Us</h3>
        <p className="about-text">
          Our head office is located at A-205, 2nd Floor, Nerul Station Complex, Nerul, Navi Mumbai – 400708, India. <br />
          Tel: <span className="highlight">+974 5078 3800</span>
        </p>
      </div>

      {/* Got a Question Section */}
      <div className="question-container">
        <h2>Got a question?</h2>
        <p>
          We are here to help you. Check out our FAQs or send an email to our support team.
        </p>
        <button className="contact-btn" onClick={handleContactUs}>Contact Us</button>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default AboutUs;